import { render, staticRenderFns } from "./exporthk2.vue?vue&type=template&id=108a2895"
import script from "./exporthk2.vue?vue&type=script&lang=js"
export * from "./exporthk2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports